import React from 'react';
import { Link } from "react-router-dom";
import { Card, Grid, Text, Group, Badge } from '@mantine/core';

import { useActions, useAppState } from 'state';

import PageHeader from 'components/layout/page/PageHeader';
import NewTenantAction from 'components/root/tenant/NewTenantAction';
import ModuleErrors from 'components/ui/ModuleErrors';
import { PageFilters, usePageFilters } from 'components/ui/PageFilters';
import { TenantFragment, Tenants_Bool_Exp, Tenant_Status_Enum } from 'state/gql/_types';
import { parseTenantStatusColor } from 'components/root/tenant/TenantUtils';
import PageLayout from 'components/layout/page/PageLayout';
import { EmptyPageComponent } from 'components/ui/Misc';
import LoadMoreButton from 'components/ui/LoadMoreButton';

const Tenants: React.FC = () => {
    const { itemsList, errors, meta, loadingMore } = useAppState(state => state.tenants)
    const { subscribeToItems, unsubscribeFromItems, getMoreItems, resetModule } = useActions().tenants

    const {
        filters,
        filterParams
    } = usePageFilters<Tenants_Bool_Exp['_and'], TenantFragment>({
        baseFilters: [],
        clickFilters: [
            {
                _or: [
                    { status: { _eq: Tenant_Status_Enum.Active } },
                    { status: { _eq: Tenant_Status_Enum.Inactive } }
                ]
            }
        ],
        searchFilterFields: ['name', 'slug', 'phone', 'address', 'city'],
        clickFilterField: 'status',
        clickFilterValues: {
            active: { label: 'Active', filter: [{ status: { _eq: Tenant_Status_Enum.Active } }] },
            inactive: { label: 'Inactive', filter: [{ status: { _eq: Tenant_Status_Enum.Inactive } }] }
        }
    })

    React.useEffect(() => {
        subscribeToItems(filters);
        return () => {
            unsubscribeFromItems()
            resetModule()
        }
    }, [filters, subscribeToItems, unsubscribeFromItems, resetModule])

    return (
        <PageLayout
            header={<PageHeader
                title='Tenants'
                renderAction={<NewTenantAction />} />
            }
        >

            <PageFilters options={filterParams} />

            <ModuleErrors errors={errors} />

            {itemsList.length ? (
                <React.Fragment>
                    <Grid>
                        {itemsList.map((i, k) => {
                            return (
                                <Grid.Col md={6} key={k}>
                                    <Card
                                        component={Link}
                                        to={`/tenants/${i.id}`}
                                        shadow="xs"
                                        sx={(theme) => ({
                                            '&:hover': {
                                                backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[9],
                                            },
                                        })}
                                    >
                                        <Group position='apart'>
                                            <Text weight={500}>{i.name}</Text>
                                            <Badge variant="outline" color={parseTenantStatusColor(i.status)}>{i.status}</Badge>
                                        </Group>
                                        <Text size='sm' component='span' color="red">{i.slug}</Text><Text size='sm' component='span'>.clutch360app.com</Text>
                                    </Card>
                                </Grid.Col>
                            )
                        })}
                    </Grid>
                    <LoadMoreButton meta={meta} onLoadMore={getMoreItems} loading={loadingMore} />
                </React.Fragment>
            ) : (
                <EmptyPageComponent label='Tenants' />
            )}

        </PageLayout>
    )
}

export default Tenants;